import { Component, OnInit, Input } from '@angular/core';

import { Controllers } from '@shared/core/controllers';
import * as Services from '@shared/core/services';
import * as State from '@shared/state';

import { Observable } from 'rxjs';
import { take, tap } from 'rxjs/operators';

@Component({
    selector: 'shared-reorder-wizzard',
    templateUrl: './reorder-wizzard.shared.component.html',
    styleUrls: ['./reorder-wizzard.shared.component.scss']
})
export class ReorderWizzardComponent implements OnInit {
    @Input() public orderId: number;
    @Input() public bottomPadding: boolean = true;

    public reorderIsValid$: Observable<boolean>;
    public reorderItems$: Observable<Array<State.ICartMenuFlowExtended | State.ICartSimpleItemExtended>>;

    constructor(
        public controllers: Controllers,
        public onlineOrdersService: Services.OnlineOrdersService,
    ) { }

    ngOnInit(): void {
        if (!this.orderId) {
            console.warn(`Invalid orderId param for reorder-wizzard component:`, this.orderId);
            return;
        }

        this.reorderItems$ = this.controllers.onlineOrders.reorderItems$(this.orderId);
    }

    public handleSelected(data: { event: Event, item: State.ICartMenuFlowExtended | State.ICartSimpleItemExtended; }): void {
        this.onlineOrdersService.reorderToggleItemSelected(this.orderId, data.item);
    }

    public handleDeselected(data: { event: Event, item: State.ICartMenuFlowExtended | State.ICartSimpleItemExtended; }): void {
        this.onlineOrdersService.reorderToggleItemSelected(this.orderId, data.item);
    }
}
